import React from "react"
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {CmCollectionType, CmTeasableType} from "../../types";


export interface Props {
    cmCollection: CmCollectionType
}

function C999E2ETest(props: Props) {
    return <>
        <CCOHeadline headline={props.cmCollection.teaserTitle}/>
        <ol data-cypress={"preview-docTypes"} > {
            props.cmCollection.items?.map(i => i as CmTeasableType).map((i: CmTeasableType, index: number) =>
                <li key={index}>
                    <strong>{i.type+ '/' + i.id}</strong>
                </li>
            )
        }
        </ol>
    </>
}

export default C999E2ETest